import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FormControl, InputLabel, MenuItem, Select, Typography, Box } from "@material-ui/core";
import ChatiaDialogActions from "../ChatiaDialogActions";

const WEBHOOK_PLATFORMS = [
  { value: "braip", label: "Braip", flag: "/imagens/flag-br.svg" },
];

const WEBHOOK_EVENTS = {
  braip: [
    { value: "cart_abandonment", label: "Abandono de carrinho" },
    { value: "pix_generated", label: "PIX gerado (sem pagamento)" },
    { value: "purchase_approved_new", label: "Pagamento aprovado (novo cliente)" },
    { value: "purchase_approved_existing", label: "Pagamento aprovado (cliente existente)" },
    { value: "payment_overdue", label: "Pagamento atrasado" },
    { value: "account_deactivated", label: "Acesso desativado" },
  ],
};

const AVAILABLE_VARS = {
  cart_abandonment: ["{{nome}}", "{{nomeCompleto}}", "{{produto}}", "{{link}}"],
  pix_generated: ["{{nome}}", "{{nomeCompleto}}", "{{produto}}"],
  purchase_approved_new: ["{{nome}}", "{{nomeCompleto}}", "{{email}}", "{{senha}}", "{{link}}"],
  purchase_approved_existing: ["{{nome}}", "{{nomeCompleto}}", "{{email}}", "{{link}}"],
  payment_overdue: ["{{nome}}", "{{nomeCompleto}}", "{{produto}}"],
  account_deactivated: ["{{nome}}", "{{nomeCompleto}}", "{{produto}}"],
};

const FlowBuilderStartModal = ({ open, onUpdate, data, close }) => {
  const [activeModal, setActiveModal] = useState(false);
  const [triggerType, setTriggerType] = useState("message");
  const [webhookPlatform, setWebhookPlatform] = useState("");
  const [webhookEvent, setWebhookEvent] = useState("");

  useEffect(() => {
    if (open === "edit" && data) {
      setTriggerType(data.data?.triggerType || "message");
      setWebhookPlatform(data.data?.webhookPlatform || "");
      setWebhookEvent(data.data?.webhookEvent || "");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  const handleClose = () => {
    setActiveModal(false);
    close(null);
  };

  const handleSave = () => {
    if (onUpdate && data) {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          triggerType,
          webhookPlatform: triggerType === "webhook" ? webhookPlatform : null,
          webhookEvent: triggerType === "webhook" ? webhookEvent : null,
        },
      });
    }
    handleClose();
  };

  const events = webhookPlatform ? (WEBHOOK_EVENTS[webhookPlatform] || []) : [];
  const vars = webhookEvent ? (AVAILABLE_VARS[webhookEvent] || []) : [];

  return (
    <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="xs" scroll="paper">
      <DialogTitle>Configurar Acionador</DialogTitle>
      <DialogContent dividers>
        <FormControl variant="outlined" fullWidth size="small" style={{ marginBottom: 16 }}>
          <InputLabel>Tipo de acionador</InputLabel>
          <Select
            value={triggerType}
            onChange={(e) => {
              setTriggerType(e.target.value);
              if (e.target.value === "message") {
                setWebhookPlatform("");
                setWebhookEvent("");
              }
            }}
            label="Tipo de acionador"
          >
            <MenuItem value="message">Mensagem (WhatsApp)</MenuItem>
            <MenuItem value="webhook">Webhook (Integracoes)</MenuItem>
          </Select>
        </FormControl>

        {triggerType === "webhook" && (
          <>
            <FormControl variant="outlined" fullWidth size="small" style={{ marginBottom: 16 }}>
              <InputLabel>Integracao</InputLabel>
              <Select
                value={webhookPlatform}
                onChange={(e) => { setWebhookPlatform(e.target.value); setWebhookEvent(""); }}
                label="Integracao"
              >
                {WEBHOOK_PLATFORMS.map((p) => (
                  <MenuItem key={p.value} value={p.value}>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <img src={p.flag} alt={p.label} style={{ width: 20, height: 14, borderRadius: 2 }} />
                      {p.label}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {webhookPlatform && (
              <FormControl variant="outlined" fullWidth size="small" style={{ marginBottom: 16 }}>
                <InputLabel>Evento</InputLabel>
                <Select
                  value={webhookEvent}
                  onChange={(e) => setWebhookEvent(e.target.value)}
                  label="Evento"
                >
                  {events.map((ev) => (
                    <MenuItem key={ev.value} value={ev.value}>{ev.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {vars.length > 0 && (
              <Box mt={1} p={1.5} style={{ backgroundColor: "rgba(0,0,0,0.04)", borderRadius: 8 }}>
                <Typography variant="caption" style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>
                  Variaveis disponiveis nos nos de mensagem:
                </Typography>
                <Typography variant="caption" style={{ fontFamily: "monospace", color: "#666" }}>
                  {vars.join("  ")}
                </Typography>
              </Box>
            )}
          </>
        )}
      </DialogContent>
      <ChatiaDialogActions
        type="button"
        onClick={handleSave}
        saveText="Salvar"
      />
    </Dialog>
  );
};

export default FlowBuilderStartModal;
